<template>
  <div>
    <b-modal
      id="modal-picture"
      v-model="pictureModal"
      hide-footer
      hide-header
      centered
      size="lg"
      modal-class="asset-photo-modal"
    >
      <div class="asset-photo-modal__header">
        <div class="asset-photo-modal__title">
          <feather-icon
            icon="ImageIcon"
            size="16"
          />
          <span>Asset Photo</span>
        </div>
        <button
          type="button"
          class="asset-photo-modal__close"
          @click="pictureModal = false"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
      </div>

      <div class="asset-photo-modal__stage">
        <img
          :src="assetPhoto"
          alt="Asset Photo"
          class="asset-photo-modal__img"
        >
      </div>

      <div class="asset-photo-modal__footer">
        <b-button
          :href="assetPhoto"
          target="_blank"
          variant="outline-primary"
          size="sm"
        >
          <feather-icon
            icon="DownloadIcon"
            size="14"
            class="mr-50"
          />
          Download
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="pictureModal = false"
        >
          Close
        </b-button>
      </div>
    </b-modal>

    <b-card
      no-body
      class="mb-0"
    >
      <b-row class="match-height">
        <b-col lg="12">
          <b-card title="Asset Return Details">
            <b-row>
              <b-col cols="6">
                <b-button
                  type="button"
                  variant="primary"
                  class="mr-1"
                  @click="previous()"
                >
                  <feather-icon
                    icon="ArrowLeftIcon"
                    size="16"
                    class="align-middle"
                  />
                  Back
                </b-button>
              </b-col>
              <b-col
                cols="6"
                class="d-flex justify-content-end"
                style="padding-top: 100px;"
              >
                <b-dropdown
                  v-if="documents.length > 0"
                  v-model="showDropdown"
                  text="Download Documents"
                  class="float-right mr-2"
                >
                  <b-dropdown-item
                    v-for="document in documents"
                    :key="document.document_number"
                    @click="downloadAttachment(document)"
                  >
                    {{ document.document_file_name }}
                  </b-dropdown-item>
                </b-dropdown>
                <div
                  v-if="assetPhoto !== ''"
                  class="asset-photo-card"
                  @click="showModal"
                >
                  <img
                    :src="assetPhoto"
                    alt="Asset Photo"
                    class="asset-photo-card__img"
                  >
                  <div class="asset-photo-card__overlay">
                    <feather-icon
                      icon="ZoomInIcon"
                      size="16"
                    />
                    <span>Preview</span>
                  </div>
                </div>
              </b-col>

              <b-col cols="12">
                <div class="divider mt-2 mb-2" />
                <b-form-group
                  label="Return Reason *"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="assetReturnCategory"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Return Note *"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="assetReturnNote"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Return PIC Name *"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="assetReturnPICName"
                    readonly
                  />
                </b-form-group>
                <hr>
                <div class="divider mt-2 mb-2" />

                <b-form-group
                  label="Item ID"
                  label-for="itemId"
                  label-cols-md="12"
                >
                  <b-form-input
                    :value="item.item ? item.item.item_code : ''"
                    placeholder="Item ID"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Asset ID"
                  label-for="assetId"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_number"
                    placeholder="Asset ID"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Ref ID"
                  label-for="refId"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_ref_id"
                    placeholder="Ref ID"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Local ID"
                  label-for="localId"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_local_id"
                    placeholder="Local ID"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Asset Group"
                  label-for="category"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_category"
                    placeholder="Asset Group"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Description"
                  label-for="description"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_description"
                    placeholder="Asset Description"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Note"
                  label-for="note"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_note"
                    placeholder="Asset Note"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="GPS"
                  label-for="gps"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_gps"
                    placeholder="Asset GPS"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Date of Acquisition"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_date_of_acquistion"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Acquisition Value"
                  label-for="assetAcquisitionValue"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_acquistion_value"
                    placeholder="Asset Acquisition Value"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Depreciation Method"
                  label-for="assetDepreciationMethod"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_depreciation_method"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Residual Value"
                  label-for="assetResidualValue"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_residual_value"
                    placeholder="Asset Residual Value"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Market Value"
                  label-for="assetMarketValue"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_market_value"
                    placeholder="Asset Market Value"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Asset Condition"
                  label-for="assetAssetCondition"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_condition"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Asset Address"
                  label-for="assetAddress"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_address"
                    placeholder="Asset Address"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Asset Responsible"
                  label-for="assetResponsible"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_responsible"
                    placeholder="Asset Responsible"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Serial Number"
                  label-for="assetSerialNumber"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_serial_no"
                    placeholder="Asset Serial Number"
                    readonly
                  />
                </b-form-group>
                <b-form-group
                  label="Warranty"
                  label-for="assetWarranty"
                  label-cols-md="12"
                >
                  <b-form-input
                    v-model="item.asset_warranty"
                    placeholder="Asset Warranty"
                    readonly
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <label>Status :</label>
                  <vue-horizontal-timeline :items="statusItems" />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BCard,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import moment from 'moment-timezone'
import { VueHorizontalTimeline } from 'vue-horizontal-timeline'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BDropdown,
    VueHorizontalTimeline,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BDropdownItem,
  },
  data() {
    return {
      documents: [],
      assetReturnPICName: '',
      assetReturnCategory: '',
      assetReturnNote: '',
      pictureModal: false,
      assetPhoto: '',
      item: {},
      statusItems: [],
      assetId: '',
      apiUrl: process.env.VUE_APP_API_URL,
      showDropdown: false,
    }
  },
  mounted() {
    this.getDetail()
    this.getDocuments()
  },
  methods: {
    getDocuments() {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }
      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_ASSET_DOCUMENTS}/${this.item.asset_id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            this.documents = response.data.data || []
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Get Documents Failed',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Get Documents Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    showModal() {
      this.pictureModal = true
    },
    getDetail() {
      const userData = this.$cookies.get('userData')
      this.assetReturnPICName = userData ? userData.user_fullname : ''
      this.item = JSON.parse(localStorage.getItem('assetDetail')) || {}
      this.assetId = this.item.asset_id
      this.assetReturnCategory = this.item.asset_is_returned_category
      this.assetReturnNote = this.item.asset_is_returned_note
      this.assetReturnPICName = this.item.asset_is_returned_pic_name

      if (this.item.asset_photo) {
        this.assetPhoto = `${process.env.VUE_APP_API_URL}upload/${this.item.asset_photo}`
      }

      const obj1 = {
        title: 'Requested',
        content: `Asset Return Has been Requested By ${
          this.item.return_finance ? this.item.return_finance.user_fullname : '-'
        } at ${this.dateSimple(
          this.item.asset_is_returned_confirmed_by_finance_date,
          'YYYY-MM-DD',
        )}`,
        stepCssClass: 'has-step-green',
        boxCssClass: 'has-color-red',
      }

      const obj2 = {
        title: 'Laboratory Manager',
        content: this.item.asset_is_returned_confirmed_by_lab_manager_id !== null
          ? `Asset Return Has been accepted by ${
              this.item.return_lab_manager ? this.item.return_lab_manager.user_fullname : '-'
            } at ${this.dateSimple(
              this.item.asset_is_returned_confirmed_by_lab_manager_date,
              'YYYY-MM-DD',
            )}`
          : 'Asset Return Has not been accepted',
        stepCssClass: this.item.asset_is_returned_confirmed_by_lab_manager_id !== null
          ? 'has-step-green'
          : 'has-step-red',
      }

      const obj3 = {
        title: 'Regional Manager',
        content: this.item.asset_is_returned_confirmed_by_regional_manager_id !== null
          ? `Asset Return Has been accepted by ${
              this.item.return_regional_manager ? this.item.return_regional_manager.user_fullname : '-'
            } at ${this.dateSimple(
              this.item.asset_is_returned_confirmed_by_regional_manager_date,
              'YYYY-MM-DD',
            )}`
          : 'Asset Return Has not been accepted',
        stepCssClass: this.item.asset_is_returned_confirmed_by_regional_manager_id !== null
          ? 'has-step-green'
          : 'has-step-red',
      }

      const obj4 = {
        title: 'Division Head',
        content: this.item.asset_is_returned_confirmed_by_division_head_id !== null
          ? `Asset Return Has been accepted by ${
              this.item.return_division_head ? this.item.return_division_head.user_fullname : '-'
            } at ${this.dateSimple(
              this.item.asset_is_returned_confirmed_by_division_head_date,
              'YYYY-MM-DD',
            )}`
          : 'Asset Return Has not been accepted',
        stepCssClass: this.item.asset_is_returned_confirmed_by_division_head_id !== null
          ? 'has-step-green'
          : 'has-step-red',
      }

      const obj5 = {
        title: 'FA Coal Manager',
        content: this.item.asset_is_returned_confirmed_by_fa_coal_manager_id !== null
          ? `Asset Return Has been accepted by ${
              this.item.return_fa_coal_manager ? this.item.return_fa_coal_manager.user_fullname : '-'
            } at ${this.dateSimple(
              this.item.asset_is_returned_confirmed_by_fa_coal_manager_date,
              'YYYY-MM-DD',
            )}`
          : 'Asset Return Has not been accepted',
        stepCssClass: this.item.asset_is_returned_confirmed_by_fa_coal_manager_id !== null
          ? 'has-step-green'
          : 'has-step-red',
      }

      this.statusItems = [obj1, obj2, obj3, obj4, obj5]
    },
    dateSimple(value, format = 'YYYY-MM-DD') {
      if (value) {
        return moment.utc(value).tz('Asia/Jakarta').format(format)
      }
      return null
    },
    previous() {
      this.$router.push({ name: 'apps-procurement-assets-list' })
    },
    downloadAttachment(document) {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }
      const FileName = document.document_file_name
      const ObjectName = `${document.document_number}${FileName}`
      const body = {
        ObjectName,
        FileName,
      }
      axios
        .post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_ASSET}`,
          body,
          { headers },
        )
        .then(response => {
          if (response.data.Status === 1) {
            window.open(response.data.Payload, '_blank')
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Download Attachment success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Something went wrong',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
    },
  },
}
</script>

<style scoped>
.asset-photo-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  background: #f4f6f8;
  box-shadow: 0 4px 14px rgba(20, 30, 50, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.asset-photo-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(20, 30, 50, 0.18);
}

.asset-photo-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.asset-photo-card__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  color: #7367f0;
  font-size: 0.7rem;
  font-weight: 600;
}

.asset-photo-card__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0) 40%, rgba(15, 23, 42, 0.72) 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.asset-photo-card:hover .asset-photo-card__overlay {
  opacity: 1;
}

.asset-photo-modal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
}

.asset-photo-modal .modal-body {
  padding: 0;
}

.asset-photo-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.asset-photo-modal__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #1f2937;
  font-size: 0.95rem;
  font-weight: 700;
}

.asset-photo-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: #f1f2f6;
  color: #4b5563;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.asset-photo-modal__close:hover {
  background: #e94b4b;
  color: #fff;
}

.asset-photo-modal__stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 1.5rem;
  background:
    linear-gradient(45deg, #f4f5f7 25%, transparent 25%),
    linear-gradient(-45deg, #f4f5f7 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #f4f5f7 75%),
    linear-gradient(-45deg, transparent 75%, #f4f5f7 75%);
  background-size: 22px 22px;
  background-position: 0 0, 0 11px, 11px -11px, -11px 0;
  background-color: #fafbfc;
}

.asset-photo-modal__img {
  max-width: 100%;
  max-height: 62vh;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.22);
}

.asset-photo-modal__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1.5rem;
  text-align: center;
}

.asset-photo-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.85rem 1.1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

@media (max-width: 575.98px) {
  .asset-photo-modal__stage {
    min-height: 220px;
    padding: 1rem;
  }
}
</style>
